import { render, staticRenderFns } from "./Debug.vue?vue&type=template&id=a50facce&scoped=true&lang=pug&"
import script from "./Debug.vue?vue&type=script&lang=ts&"
export * from "./Debug.vue?vue&type=script&lang=ts&"
import style0 from "./Debug.vue?vue&type=style&index=0&id=a50facce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50facce",
  null
  
)

component.options.__file = "Debug.vue"
export default component.exports